import {
  ConversationStatus,
  ListConversationsFiltersThunk,
} from "./types/queries";

export type ConversationInbox = "TEAM" | "MY";

export type InboxTabId = "teamOpen" | "myOpen" | "inProgress" | "closed";

export type InboxTab = {
  id: InboxTabId;
  inbox: ConversationInbox;
  status: ConversationStatus;
};

export const INBOX_TABS: InboxTab[] = [
  {
    id: "teamOpen",
    inbox: "TEAM",
    status: ConversationStatus.OPEN,
  },
  {
    id: "myOpen",
    inbox: "MY",
    status: ConversationStatus.OPEN,
  },
  {
    id: "inProgress",
    inbox: "MY",
    status: ConversationStatus.IN_PROGRESS,
  },
  {
    id: "closed",
    inbox: "MY",
    status: ConversationStatus.CLOSED,
  },
];

export const IN_PROGRESS_TAB_INDEX = INBOX_TABS.findIndex(
  (tab) => tab.id === "inProgress",
);

type InboxConversation = {
  status: ConversationStatus;
  assigneeId?: string | null;
  teamIds?: string[];
};

export const isTeamOpenConversation = (conversation: InboxConversation) =>
  conversation.status === ConversationStatus.OPEN &&
  !conversation.assigneeId &&
  (conversation.teamIds?.length ?? 0) > 0;

export const inboxTabForConversation = (
  conversation: InboxConversation,
): InboxTabId | null => {
  if (conversation.status === ConversationStatus.CLOSED) return "closed";
  if (conversation.status === ConversationStatus.IN_PROGRESS) {
    return "inProgress";
  }
  if (conversation.status !== ConversationStatus.OPEN) return null;
  return isTeamOpenConversation(conversation) ? "teamOpen" : "myOpen";
};

export const matchesInboxTab = (
  conversation: InboxConversation,
  tabId: InboxTabId,
) => {
  switch (tabId) {
    case "teamOpen":
      return isTeamOpenConversation(conversation);
    case "myOpen":
      return (
        conversation.status === ConversationStatus.OPEN &&
        !isTeamOpenConversation(conversation)
      );
    case "inProgress":
      return conversation.status === ConversationStatus.IN_PROGRESS;
    case "closed":
      return conversation.status === ConversationStatus.CLOSED;
  }
};

export const findInboxTab = (
  inbox: ConversationInbox | undefined,
  status: ConversationStatus,
) => INBOX_TABS.find((tab) => tab.inbox === inbox && tab.status === status);

export const openInboxRefreshRequest = (
  tabId: InboxTabId,
): ListConversationsFiltersThunk | null => {
  const request = activeInboxRefreshRequest(tabId);
  if (!request || request.status !== ConversationStatus.OPEN) return null;
  return request;
};

export const activeInboxRefreshRequest = (
  tabId: InboxTabId,
): ListConversationsFiltersThunk | null => {
  const tab = INBOX_TABS.find((item) => item.id === tabId);
  if (!tab) return null;
  return {
    inbox: tab.inbox,
    status: tab.status,
    reset: true,
  };
};
